module.exports = __webpack_public_path__ + "static/media/agilis-divida.06476a89.svg";